//// ~~~~~~~~~~~~~~~~~~~~~~~~~ START: METHODS TO SIMULATE ASYNC API CALLS ~~~~~~~~~~~~~~~~~~~~~~~~~ ////
//axios
import axios from 'axios';

import { url } from 'utils/urls';
// API CALL DATA STRUCTURES
// const generalInformation = {
//     accountName: 'Insticator',
//     companyAddress: '2 Park Avenue',
//     city: 'NYC',
//     zipCode: '10016',
//     state: 'NY',
//     country: 'United States'
// };

// const usersData = {
//     abc123: {
//         firstName: 'Jonathan',
//         lastName: 'Aquino',
//         email: 'JonathanAquino@insticator.com',
//         phone: '212-355-5555',
//         editPayment: true,
//         changePermissions: true,
//         signAgreement: false,
//         manageSites: false,
//         editAccount: true,
//         adstxt: true,
//         scheduleReports: false,
//         createEmbeds: true
//     },
//     xyz789: {
//         firstName: 'Vlad',
//         lastName: 'Deev',
//         email: 'Vlad@insticator.com',
//         phone: '212-355-5555',
//         editPayment: false,
//         changePermissions: false,
//         signAgreement: true,
//         manageSites: false,
//         editAccount: false,
//         adstxt: false,
//         scheduleReports: false,
//         createEmbeds: true
//     }
// };


// SIMULATE API CALLS

//General Info
export const asyncGetGeneralInfo = (accountUUID) => axios.get(`${url.accountSettings.general}/${accountUUID}`, {withCredentials: true});

export const asyncUpdateGeneralInfo = (data, formName, accountUUID) => axios.put(`${url.accountSettings.general}/${accountUUID}`, data, {withCredentials: true});


//Edit User Info

export const asyncGetUsers = (accountUUID) => axios.get(`${url.users.getUsers}${accountUUID}/users/permissions`, {withCredentials: true});

export const asyncEditUserInfo = (data, formName, userUUID) => axios.put(`${url.users.updateUser}${userUUID}/permissions`, data, {withCredentials: true});

export const asyncDeleteUser = (userUUID) => axios.delete(`${url.users.updateUser}${userUUID}`, {withCredentials: true});


//Add User

export const asyncAddUser = (data, formName, accountUUID)  => axios.post(`${url.users.addUser}${accountUUID}/users/permissions`, data, {withCredentials: true});

// Agreement
export const getAgreement = (accountUUID) => axios.get(`${url.accountSettings.getAgreement}/${accountUUID}/agreements`, {withCredentials: true});
export const updateAgreement = (agreementUUID) => axios.put(`${url.accountSettings.updateAgreement}/${agreementUUID}`, {}, {withCredentials: true});

//Resend Invite
export const asyncResendInvite = (userUUID) => axios.post(`${url.users.resendInvite}`, {userUUID} , {withCredentials: true});

//Payment Information

export const asyncGetPaymentInformation = (accountUUID) => axios.get(`${url.paymentInformation}/${accountUUID}/paymentinfo`, {withCredentials: true});

export const asyncGetCheckInformation = (paymentUUID) => axios.get(`${url.existingPaymentInformation}/check/${paymentUUID}`, {withCredentials: true});

export const asyncGetACHInformation = (paymentUUID) => axios.get(`${url.existingPaymentInformation}/ach/${paymentUUID}`, {withCredentials: true});

export const asyncGetPayPalInformation = (paymentUUID) => axios.get(`${url.existingPaymentInformation}/paypal/${paymentUUID}`, {withCredentials: true});

export const asyncGetWireTransferInformation = (paymentUUID) => axios.get(`${url.existingPaymentInformation}/wire/${paymentUUID}`, {withCredentials: true});

//  async payment information put requests

export const asyncSavePaymentInformation = (data, paymentType, accountUUID) =>{
    switch (paymentType) {
        case `PAYPAL`:
            return axios.post(`${url.paymentInformation}/${accountUUID}/paymentinfo/paypal`, data, {withCredentials: true});
        case `ACH`:
            return axios.post(`${url.paymentInformation}/${accountUUID}/paymentinfo/ach`, data, {headers: {'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true} );
        case `CHECKS`:
            return axios.post(`${url.paymentInformation}/${accountUUID}/paymentinfo/check`, data, {headers: {'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true});
        case `WIRE`:
            return axios.post(`${url.paymentInformation}/${accountUUID}/paymentinfo/wire`, data, {headers:{'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true});
        default :
            break;
    }
};
export const asyncUpdatePaymentInformation = (data, paymentType, paymentUUID) =>  {
    switch (paymentType) {
        case `PAYPAL`:
            return axios.put(`${url.existingPaymentInformation}/paypal/${paymentUUID}`, data, {withCredentials: true});
        case `ACH`:
            return axios.put(`${url.existingPaymentInformation}/ach/${paymentUUID}`, data, {headers: {'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true} );
        case `CHECKS`:
            return axios.put(`${url.existingPaymentInformation}/check/${paymentUUID}`, data, {headers: {'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true});
        case `WIRE`:
            return axios.put(`${url.existingPaymentInformation}/wire/${paymentUUID}`, data, {headers:{'Accept': 'application/json','Content-Type': 'multipart/form-data'}, withCredentials: true});
        default :
            break;
    }
};
// async ADSTXT get requests

export const asyncGetAdsTxt = (paramString) => axios({method: 'get', url: `${url.adsTxt.getAdsTxt}${paramString}`});
export const asyncVerifyAdsTxt = (paramString) => axios({method: 'get', url: `${url.adsTxt.verifyAdsTxt}${paramString}`});


// Account Data
export const getAllSitesCall = accountUUID => axios.get(`${url.getSiteCountriesEmbeds}${accountUUID}/sites?filterRonSites=false`, {withCredentials: true});

